import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/pages/home";
import landingPg from "@/components/pages/landingPage";
import movieDetails from "@/components/pages/movieDetails";
import quickMovie from "@/components/pages/quickMovieDetails";
import failedPayment from "@/components/pages/failedBookingNew";
import store from "../store/modules/empStore";
// import checkout from "@/components/pages/checkout";
import fb from "@/components/pages/foodBeverage";
import iraq from "@/components/pages/iraq";
import ksa from "@/components/pages/ksa";
import seatlayout from "@/components/pages/seatLayout";
import seatlayoutNew from "@/components/pages/seatLayoutNew";
import fnb from "@/components/pages/fnb";
import fnbNew from "@/components/pages/fnbNew";
import test from "@/components/pages/testnew";
import fnbcheckout from "@/components/pages/fnbcheckout";
import error404 from "@/components/pages/error404";
import profile from "@/components/pages/profile";
import browseByCinemaTwo from "@/components/pages/browseByCinemaTwo";
import bookanevent from "@/components/pages/bookanevent";
import ticketconfirmation from "@/components/pages/ticket-confirmation";
import foodticket from "@/components/pages/fticket";
import browsebycinema from "@/components/pages/browseByCinema";
import mobaboutUs from "@/components/pages/mob-about-us";
import termsAndCondition from "@/components/pages/terms-and-condition";
import ksaPrivacyPolicy from "@/components/pages/ksaPrivacyPolicy";
import mobTnc from "@/components/pages/mob-tnc";
import getApp from "@/components/pages/getapp";
import scanQr from "@/components/pages/scanQr";
import comingSoonMovies from "@/components/pages/coming-soon-movies";
import ksaTermsAndConditions from "@/components/pages/ksa-terms-condition.vue";
import theatreRules from "@/components/pages/theatre-rules.vue";
import Offers from "@/components/pages/offers.vue";
import langChange from "@/components/pages/langChange.vue";
import langEngChange from "@/components/pages/langEngChange.vue";
import howItWorks from "@/components/pages/howItWorks";

import privacyPolicy from "@/components/pages/privacypolicy.vue";

import experience from "@/components/pages/experience-list.vue";
import experienceDetails from "@/components/pages/experience-detail.vue";
import letsMovie from "@/components/pages/letsMovie.vue";

import mobKsaTnc from "@/components/pages/mob-ksa-tnc.vue";
import theatreRulesMob from "@/components/pages/theatre-rules-mob.vue";

/** ***NEW WEBSITE ROUTES */

import home from "@/components/pages/home.vue";
import screenxexp from "@/components/pages/experience/screenxcinema.vue";
import screenxexpo1 from "@/components/pages/experience/premiere.vue";
import experienceScreen from "@/components/pages/experience/experienceScreen.vue";
import cinemaoffer from "@/components/pages/offer/cinemaoffers.vue";
import privatebooking from "@/components/pages/offer/privatebooking.vue";

import aboutus from "@/components/pages/aboutus.vue";
import career from "@/components/pages/career.vue";
import foodmenus from "@/components/pages/food-drinks/foodmenus.vue";
import foodpremiere from "@/components/pages/food-drinks/foodpremiere.vue";
import premiumMenuScanner from "@/components/pages/food-drinks/premiumMenuScanner.vue";
import orderonline from "@/components/pages/food-drinks/orderonline.vue";

import bookevent from "@/components/pages/bookevent.vue";
import login from "@/components/pages/login.vue";
import forgotpassword from "@/components/pages/forgotpassword.vue";
import otp from "@/components/pages/otp.vue";
import phoneOtp from "@/components/pages/phoneOtp.vue";
import hometwo from "@/components/pages/hometwo.vue";
import cinemalocation from "@/components/pages/cinemalocation.vue";
import LoyaltyHowItWorks from "@/components/pages/LoyaltyHowItWorks.vue";

import loyaltyForm from "@/components/pages/loyaltyForm.vue";
import clubEmpire from "@/components/pages/clubEmpire.vue";
import cinemashowtimes from "@/components/pages/cinemashowtimes.vue";
import allCinemashowtimes from "@/components/pages/allCinemashowtimes.vue";

import contactus from "@/components/pages/contactus.vue";
import finalticket from "@/components/pages/finalticket.vue";
import finalticketNew from "@/components/pages/finalticketNew.vue";
import selectpayment from "@/components/pages/selectpayment.vue";
import confirmation from "@/components/pages/confirmationNew.vue";
import vipfnbmenue from "@/components/pages/vipfnbmenue.vue";
import reservationDetails from "@/components/pages/reservationDetails.vue";
import { LanguageService } from "@/services/storage.service";
Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: function() {
    return {
      x: 0,
      y: 0,
    };
  },

  routes: [
    {
      path: "/landingpage",
      name: "LandingPage",
      component: landingPg,
    },
    {
      path: "/countries",
      name: "LandingPage",
      component: landingPg,
    },
    {
      path: "/ar",
      name: "langChange",
      component: langChange,
    },
    {
      path: "/en",
      name: "langEngChange",
      component: langEngChange,
    },
    {
      path: "/",
      name: "Home",
      component: !localStorage.getItem("language") ? landingPg : home,
    },

    // {
    //   path: "/iraq",
    //   name: "Iraq",
    //   component: iraq,
    // },
    // {
    //   path: "/ksa",
    //   name: "Ksa",
    //   component: ksa,
    // },
    {
      name: "bookByCinema",
      path: "/book-by-cinema",
      component: browsebycinema,
    },
    {
      name: "browseByCinema",
      path: "/browse-by-cinema/:cinemaId",
      component: browseByCinemaTwo,
    },
    {
      name: "comingSoonMovies",
      path: "/comingSoonMovies",
      component: comingSoonMovies,
    },
    {
      path: "/lets-eat/:cinemaId",
      name: "foodBeverage",
      component: fnbcheckout,
    },
    {
      path: "/Vip-Menu",
      name: "vipfnbmenue",
      component: vipfnbmenue,
    },
    {
      path: "/terms-and-condition",
      name: "terms-and-condition",
      component: termsAndCondition,
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: privacyPolicy,
    },
    {
      path: "/offers",
      name: "Offers",
      component: Offers,
    },
    {
      path: "/bookanevent",
      name: "bookanevent",
      component: bookanevent,
    },
    {
      path: "/profile",
      name: "profile",
      component: profile,
    },
    {
      path: "/howItWorks",
      name: "howItWorks",
      component: howItWorks,
    },

    {
      path: "/experience",
      name: "Experience",
      component: experience,
    },

    {
      path: "/experience-details",
      name: "Experience Detail",
      component: experienceDetails,
    },
    {
      path: "/terms-condition",
      name: "termsAndCondition",
      component: termsAndCondition,
    },
    {
      path: "/ksa-terms-condition",
      name: "ksaTermsAndConditions",
      component: ksaTermsAndConditions,
    },
    {
      path: "/ksa-privacy-policy",
      name: "ksaPrivacyPolicy",
      component: ksaPrivacyPolicy,
    },
    {
      path: "/mob-ksa-tnc/:lang/:cinemaType",
      name: "mobKsaTnc",
      component: mobKsaTnc,
    },
    {
      path: "/theatre-rules-mob/:lang/:cinemaType",
      name: "theatreRulesMob",
      component: theatreRulesMob,
    },
    {
      path: "/theatre-rules",
      name: "theatreRules",
      component: theatreRules,
    },
    {
      path: "/about-us",
      name: "aboutus",
      component: aboutus,
    },
    {
      path: "/career",
      name: "career",
      component: career,
    },
    {
      path: "/mob-about-us/:lang/:cinemaType",
      name: "mobaboutUs",
      component: mobaboutUs,
    },
    {
      path: "/mob-tnc/:lang/:cinemaType",
      name: "mobTnc",
      component: mobTnc,
    },
    {
      name: "movieDetails",
      // path: "/movie/:movieId",
      path: "/movie/:movieId/:formatId",
      component: movieDetails,
      meta: {
        transitionName: "slide",
      },
    },
    {
      path: "/lets-movie/:qrName",
      name: "letsMovie",
      component: letsMovie,
    },
    {
      path: "/quickMovie",
      name: "quickMovie",
      component: quickMovie,
    },
    {
      path: "/test",
      name: "test",
      component: test,
    },
    {
      path: "/checkout/:movieID/:scheduleID/:seatLayout",
      // path: '/checkout',
      name: "checkout",
      component: seatlayout,
    },
    {
      path: "/seatlayout/:scheduleID",
      name: "seatlayout",
      component: seatlayout,
    },
    {
      path: "/seatlayout/:ss_id/:md_id/:screen_id",
      name: "seatlayout",
      component: seatlayoutNew,
    },
    {
      path: "/confirmation/:reserveID",
      // path: '/confirmation',
      name: "ticketconfirmation",
      component: ticketconfirmation,
    },
    {
      path: "/failedPayment/:reserveId",
      name: "failedPayment",
      component: failedPayment,
    },
    {
      path: "/fticket",
      name: "ftickek",
      component: foodticket,
    },
    {
      path: "/getApp",
      name: "getApp",
      component: getApp,
    },
    {
      path: "/scanQr",
      name: "scanQr",
      component: scanQr,
    },

    {
      path: "*",
      name: "error404",
      component: error404,
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/forgot-password",
      name: "forgotpassword",
      component: forgotpassword,
    },
    {
      path: "/otp",
      name: "otp",
      component: otp,
    },
    {
      path: "/phoneotp",
      name: "phoneotp",
      component: phoneOtp,
    },
    {
      path: "/",
      name: "home",
      component: home,
    },

    {
      path: "/screenx/:expID/:expName",
      name: "screenxexp",
      component: screenxexp,
    },
    {
      path: "/premiere/:expID/:expName",
      name: "premiereExp",
      component: screenxexpo1,
    },
    {
      path: "/experienceScreen",
      name: "experienceScreen",
      component: experienceScreen,
    },

    {
      path: "/cinema-offer",
      name: "cinemaoffer",
      component: cinemaoffer,
    },
    {
      path: "/private-booking",
      name: "privatebooking",
      component: privatebooking,
    },
    {
      path: "/home-two",
      name: "hometwo",
      component: hometwo,
    },
    {
      path: "/location",
      name: "cinemalocation",
      component: cinemalocation,
    },
    {
      path: "/LoyaltyHowItWorks",
      name: "LoyaltyHowItWorks",
      component: LoyaltyHowItWorks,
    },
    {
      path: "/clubEmpire",
      name: "clubEmpire",
      component: clubEmpire,
    },
    {
      path: "/loyaltyForm",
      name: "loyaltyForm",
      component: loyaltyForm,
    },
    {
      path: "/menu",
      name: "foodmenus",
      component: foodmenus,
    },
    {
      path: "/premiere",
      name: "foodpremiere",
      component: foodpremiere,
    },
    {
      path: "/premiumMenuScanner",
      name: "premiumMenuScanner",
      component: premiumMenuScanner,
    },
    {
      path: "/order-online",
      name: "orderonline",
      component: orderonline,
    },
    {
      path: "/book-event",
      name: "Bookevent",
      component: bookevent,
    },
    {
      path: "/showtimes/:cat_id/:movieId/:movieName/:expName?",
      // path: "/showtimes",
      name: "cinemashowtimes",
      component: cinemashowtimes,
    },
    {
      path: "/allCinemashowtimes",
      // path: "/showtimes",
      name: "allCinemashowtimes",
      component: allCinemashowtimes,
    },

    {
      path: "/contact-us",
      name: "contactus",
      component: contactus,
    },
    // {
    //   path: '/food-and-drinks/:reserveId',
    //   name: 'fnb',
    //   component: fnb,
    // },
    {
      path: "/food-and-drinks/:reserveId",
      name: "fnb",
      component: fnbNew,
    },
    {
      path: "/final-ticket/:reserveId",
      name: "finalticket",
      component: finalticket,
    },
    {
      path: "/reservation-details/:bookingId",
      name: "reservationDetails",
      component: reservationDetails,
    },
    {
      path: "/final-ticket/:bookingId/:categoryId",
      name: "finalticket",
      component: finalticketNew,
    },
    {
      path: "/select-payment/:reserveId",
      name: "selectpayment",
      component: selectpayment,
    },
    {
      path: "/ticket-confirmation/:reserveId",
      name: "ticketConfirmation",
      component: confirmation,
    },
  ],
});

router.beforeEach((to, from, next) => {
  let lang = window.localStorage.getItem("language");
  let country = window.localStorage.getItem("country");
  let profileDetails = JSON.parse(
    window.localStorage.getItem("profile_detail")
  );
  let guestProfileDetail = JSON.parse(
    window.localStorage.getItem("guest_detail")
  );

  let isguestMobileVerified = localStorage.getItem("guestMobileVerfied");
  // console.log(isguestMobileVerified, "isguestMobileVerified");
  let isProfile = window.localStorage.getItem("isProfile");

  let to_update =
    profileDetails &&
    (!profileDetails.CountryID ||
      !profileDetails.Gender ||
      !profileDetails.Mobile ||
      !profileDetails.verfiymobile ||
      !profileDetails.FirstName ||
      profileDetails.Mobile.includes("90000"));
  // console.log(to_update, "to_update");
  // console.log(isProfile, "isProfile");
  if (to_update && to.fullPath == "/profile" && from.fullPath == "/otp") {
    // console.log("first if");
    return next({ path: "/profile" });
    // return next();
  } else if (isProfile && to.fullPath == "/phoneOtp") {
    // console.log("second if");
    return next();
  } else if (
    to_update &&
    to.fullPath != "/profile" &&
    to.fullPath != "/phoneOtp"
  ) {
    // console.log("third if");
    return next({ path: "/profile" });
  }
  // else if (to.fullPath == "/otp" && from.fullPath == "/phoneOtp") {
  //   console.log("new if");
  //   return next({ path: "/profile" });
  // }
  //  else if (
  //   profileDetails &&
  //   profileDetails.verfiymobile &&
  //   to.fullPath == "/profile"
  // ) {
  //   console.log("fourth if");
  //   return next({ path: "/phoneOtp" });
  // }
  else if (!to_update && to.fullPath == "/phoneOtp") {
    // console.log("fourth if");
    return next();
  }
  //  else if (to_update && to.fullPath == "/phoneOtp") {
  //   console.log("fifth if");
  //   return next();
  // } else if (!to_update && to.fullPath == "/phoneOtp") {
  //   console.log("fifth if");
  //   return next();
  // }
  else if (to.name === "ticketConfirmation") {
    // console.log(
    //   store.state.enableConfirmationAccess.status,
    //   "store.state.enableConfirmationAccess.status"
    // );
    if (!store.state.enableConfirmationAccess.status) {
      next({ path: "/" });
    } else {
      next();
    }
  } else if (
    (!lang || !country) &&
    (to.fullPath === "/" ||
      to.fullPath === "/premiumMenuScanner" ||
      to.fullPath === "/ksa-terms-condition" ||
      to.fullPath.includes("/reservation-details") ||
      to.fullPath.includes("/final-ticket/"))
  ) {
    // console.log("fifth if");
    // console.log({ "to.fullPath": to.fullPath });
    // console.log({ "from.fullPath": from.fullPath });

    return next();
  }

  //  else if (
  //   !profileDetails &&
  //   (to.fullPath == "/LoyaltyHowItWorks" || to.fullPath == "/clubEmpire")
  // ) {
  //   return next({ path: "/login" });
  // }
  else if (!lang || !country) {
    // console.log("sixth if");
    window.localStorage.clear();

    return next({ path: "/" });
  } else if (to.fullPath == "/phoneOtp" && isguestMobileVerified) {
    return next({ path: "/" });
  } else {
    // console.log("seventh if");
    return next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js